import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=ba8f9f38&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8f9f38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba8f9f38')) {
      api.createRecord('ba8f9f38', component.options)
    } else {
      api.reload('ba8f9f38', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=ba8f9f38&scoped=true&", function () {
      api.rerender('ba8f9f38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HcnCGlfH4h0n/JS/comp/SearchFilterTokens.vue"
export default component.exports